/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { computed } from 'vue';
import { usePrefixClass } from '../../hooks/useConfig.mjs';
import { COMPONENT_NAME } from '../const.mjs';
import '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-97c71289.mjs';
import '../../_chunks/dep-6f3e4f56.mjs';
import '../../_chunks/dep-b1060562.mjs';
import '../../_chunks/dep-b333ab93.mjs';
import '../../_chunks/dep-4efc69ee.mjs';
import '../../_chunks/dep-493c38ce.mjs';
import '../../_chunks/dep-b56b2dc0.mjs';
import '../../_chunks/dep-77f634fb.mjs';
import '../../_chunks/dep-28ae3cda.mjs';
import '../../_chunks/dep-e50fa7b0.mjs';
import '../../_chunks/dep-ae08d6c4.mjs';
import '../../_chunks/dep-7211604f.mjs';
import '../../_chunks/dep-75df64b1.mjs';
import '../../_chunks/dep-48b9a098.mjs';
import '../../_chunks/dep-c7e4942d.mjs';
import '../../_chunks/dep-8049d2e0.mjs';
import '../../_chunks/dep-0d1bd08c.mjs';
import '../../_chunks/dep-c5d88cfe.mjs';
import '../../_chunks/dep-25d66c95.mjs';
import '../../_chunks/dep-372265bb.mjs';
import '../../_chunks/dep-d940e2da.mjs';
import '../../_chunks/dep-52c1d6a9.mjs';
import '../../_chunks/dep-18bb982b.mjs';
import '../../_chunks/dep-c57d8117.mjs';
import '../../_chunks/dep-6043e9fc.mjs';
import '../../_chunks/dep-5f6c8826.mjs';
import '../../_chunks/dep-3a045465.mjs';
import '../../_chunks/dep-53dc0ac1.mjs';
import '../../_chunks/dep-b6b4eaa3.mjs';
import '../../_chunks/dep-881cffb7.mjs';
import '../../_chunks/dep-436b338d.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../_chunks/dep-2d31a683.mjs';
import '../../_chunks/dep-3ddc95d0.mjs';
import '../../config-provider/type.mjs';

function useCalendarClass(props, state) {
  var prefixClass = usePrefixClass(COMPONENT_NAME);
  var body = computed(function () {
    return ["".concat(prefixClass.value), "".concat(prefixClass.value, "--").concat(props.theme)];
  });
  var panel = computed(function () {
    return ["".concat(prefixClass.value, "__panel"), "".concat(prefixClass.value, "__panel--").concat(state.curSelectedMode)];
  });
  var control = computed(function () {
    return ["".concat(prefixClass.value, "__control")];
  });
  var title = computed(function () {
    return ["".concat(prefixClass.value, "__title")];
  });
  var controlSection = computed(function () {
    return ["".concat(prefixClass.value, "__control-section")];
  });
  var controlSectionCell = computed(function () {
    return ["".concat(prefixClass.value, "__control-section-cell")];
  });
  var controlTag = computed(function () {
    return ["".concat(prefixClass.value, "__control-tag")];
  });
  var table = computed(function () {
    return ["".concat(prefixClass.value, "__table")];
  });
  var tableHead = computed(function () {
    return ["".concat(prefixClass.value, "__table-head")];
  });
  var tableHeadRow = computed(function () {
    return ["".concat(prefixClass.value, "__table-head-row")];
  });
  var tableHeadCell = computed(function () {
    return ["".concat(prefixClass.value, "__table-head-cell")];
  });
  var tableBody = computed(function () {
    return ["".concat(prefixClass.value, "__table-body")];
  });
  var tableBodyRow = computed(function () {
    return ["".concat(prefixClass.value, "__table-body-row")];
  });
  return {
    body: body,
    panel: panel,
    control: control,
    title: title,
    controlSection: controlSection,
    controlSectionCell: controlSectionCell,
    controlTag: controlTag,
    table: table,
    tableHead: tableHead,
    tableHeadRow: tableHeadRow,
    tableHeadCell: tableHeadCell,
    tableBody: tableBody,
    tableBodyRow: tableBodyRow
  };
}
function useCalendarCellClass() {
  var prefixClass = usePrefixClass(COMPONENT_NAME);
  var tableBodyCell = computed(function () {
    return ["".concat(prefixClass.value, "__table-body-cell")];
  });
  var tableBodyCell4Now = computed(function () {
    return "".concat(prefixClass.value, "__table-body-cell--now");
  });
  var tableBodyCellDisplay = computed(function () {
    return ["".concat(prefixClass.value, "__table-body-cell-display")];
  });
  var tableBodyCellCsontent = computed(function () {
    return ["".concat(prefixClass.value, "__table-body-cell-content")];
  });
  return {
    tableBodyCell: tableBodyCell,
    tableBodyCell4Now: tableBodyCell4Now,
    tableBodyCellDisplay: tableBodyCellDisplay,
    tableBodyCellCsontent: tableBodyCellCsontent
  };
}

export { useCalendarCellClass, useCalendarClass };
//# sourceMappingURL=useCalendarClass.mjs.map
